import Phaser from 'phaser'

export default class EditorHandle extends Phaser.GameObjects.Container {
  constructor (scene, x, y, parentEditor, callback, texture = 'circle', deleteCallback) {
    super(scene)
    this.scene = scene
    this.parentEditor = parentEditor
    this.callback = callback
    this.deleteCallback = deleteCallback

    // if (texture !== 'circle') {
    // this.image = this.scene.matter.add.image(x, y, texture)
    // } else {
    this.image = this.scene.matter.add.image(x, y, 'images', texture)
    // }
    this.image.setDepth(900)
    this.image.setIgnoreGravity(true)
    this.image.setSensor(true)
    this.image.setInteractive({
      draggable: true
    })
    this.image.on('drag', (pointer, dragX, dragY) => {
      var p = this.scene.cameras.main.getWorldPoint(pointer.x, pointer.y)
      this.callback(Math.ceil(p.x / 10) * 10, Math.ceil(p.y / 10) * 10)
    })
    this.image.on('pointerdown', (pointer, localX, localY, event) => {
      if (this.scene.input.activePointer.rightButtonDown()) {
        if (this.deleteCallback) {
          // doesnt work well yet, so disabled. Moving on for now..
          // this.scene.levelEditor.showDeleteMenu(this.scene.input.activePointer.x, this.scene.input.activePointer.y, this.deleteCallback)
        } else {
          this.scene.levelEditor.showObjectMenu(this.scene.input.activePointer.x, this.scene.input.activePointer.y, this.parentEditor.editable)
        }
      } else if (this.scene.input.activePointer.leftButtonDown()) {
        if (this.scene.levelEditor.waitingForAttach) {
          this.scene.levelEditor.currentEditable.attachTo(this.parentEditor.editable, this.scene.levelEditor.currentEditable.image.x - this.parentEditor.editable.image.x, this.scene.levelEditor.currentEditable.image.y - this.parentEditor.editable.image.y)
          this.scene.levelEditor.currentEditable.onEdit()
          this.scene.levelEditor.waitingForAttach = false
        }
      }
    })

    this.hide()
  }

  show () {
    this.image.setVisible(true)
  }

  hide () {
    this.image.setVisible(false)
  }

  delete () {
    this.image.destroy()
    this.destroy()
  }
}
